import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";

import GenericSingleSelect from "@/components/GenericSingleSelect";
import useStore from "@/modules/store";
import { fetchWithCache } from "@/modules/api_cache";

export default class extends Controller {
  static values = { props: Object };

  connect() {
    this.renderComponent();
  }

  propsValueChanged() {
    this.renderComponent();
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }

  async renderComponent() {
    const props = this.propsValue;
    const storeId = props.storeId;
    const hiddenId = props.hiddenId;
    const hiddenInput = document.getElementById(hiddenId);
    const selectedId = props.selectedId
      ? parseInt(props.selectedId, 10)
      : null;

    if (storeId && storeId.indexOf("NEW_RECORD") !== -1) {
      return;
    }

    if (selectedId && hiddenInput) {
      hiddenInput.value = selectedId;
      const errorHelperId = hiddenInput.getAttribute("data-helper-id");
      if (errorHelperId) {
        const errorHelper = document.getElementById(errorHelperId);
        if (errorHelper) {
          errorHelper.classList.remove("block");
        }
      }
    }

    const handleOptionChange = (selectedOptionValue) => {
      if (hiddenInput) {
        hiddenInput.value = selectedOptionValue || "";
        const errorHelperId = hiddenInput.getAttribute("data-helper-id");
        if (errorHelperId && selectedOptionValue) {
          const errorHelper = document.getElementById(errorHelperId);
          if (errorHelper) {
            errorHelper.classList.remove("block");
          }
        }
      }
    };

    if (!this.root) {
      this.root = createRoot(this.element);
    }

    this.root.render(
      React.createElement(GenericSingleSelect, {
        ...props,
        selectedId,
        onChange: handleOptionChange,
      }),
    );

    if (hiddenInput && hiddenInput.value) {
      const setSelectValue = useStore.getState().setSelectValue;
      let storedSelectedId = parseInt(hiddenInput.value, 10);
      if (isNaN(storedSelectedId)) {
        storedSelectedId = hiddenInput.value;
      }
      const option = await this.fetchOptionById(storedSelectedId);
      if (option) {
        setSelectValue(
          storeId,
          { id: option.id, name: option.name },
          props.required,
        );
      }
    }

    this.dispatch("initialized");
  }

  async fetchOptionById(id) {
    try {
      const [collectionApiPath, queryString] = this.propsValue.apiPath.split("?");
      const apiPath = collectionApiPath.includes("categories/")
        ? "categories"
        : collectionApiPath;
      const detailApiPath = queryString
        ? `${apiPath}/${id}?${queryString}`
        : `${apiPath}/${id}`;
      const data = await fetchWithCache(detailApiPath);

      if (
        !data ||
        !Object.prototype.hasOwnProperty.call(data, "id") ||
        !Object.prototype.hasOwnProperty.call(data, "name")
      ) {
        throw new Error("Invalid data format");
      }

      return { id: data.id, name: data.name };
    } catch (error) {
      console.error("Error fetching option by ID:", error);
      console.error("ID:", id);
      console.error("API Path:", this.propsValue.apiPath);
    }
  }
}
